/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationDropdownContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_viewer" | "UserBanPopoverContainer_viewer">;
    readonly " $refType": "ModerationDropdownContainer_viewer";
};
export type ModerationDropdownContainer_viewer$data = ModerationDropdownContainer_viewer;
export type ModerationDropdownContainer_viewer$key = {
    readonly " $data"?: ModerationDropdownContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationDropdownContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationDropdownContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerationActionsContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBanPopoverContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'a1a5e3b64aa31c3aef5c22a68dd482d9';
export default node;
